import { jwtDecode } from 'jwt-decode';
import { create } from 'zustand';
import { mutative } from 'zustand-mutative';

import { refreshToken } from '@/apis/user.api.ts';
import type { User } from '@/models';

import { LS_KEYS } from '../keys/ls_keys.ts';

export type UserStore = {
  user?: User | null;
};

export const useUserStore = create<UserStore>()(
  mutative((_set) => {
    let userStore = null;
    try {
      userStore = JSON.parse(
        localStorage.getItem(LS_KEYS.USER) ?? JSON.stringify({}),
      ) as UserStore;
    } catch (e) {
      console.error(e);
      userStore = {};
    }

    return userStore;
  }),
);

export function setUser(user: User | null) {
  useUserStore.setState((draft) => {
    const userData = {
      user,
    };

    localStorage.setItem(LS_KEYS.USER, JSON.stringify(userData));

    // Update all fields in the store
    draft.user = user;
  });
}

export function useUser() {
  return useUserStore((v) => v.user);
}

//

setInterval(refreshUser, 5 * 60 * 1000);

export async function refreshUser() {
  const user = useUserStore.getState().user;
  if (!user) {
    return;
  }

  const payload = jwtDecode(user.accessToken);
  // If expiration time is less than 15 minutes, refresh user
  if (payload.exp! < Math.floor(Date.now() / 1000) + 15 * 60) {
    const newUser = await refreshToken();
    setUser(newUser!);
  }
}
